var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51008 5.85237C9.15239 6.27318 9.20356 6.90427 9.62437 7.26196L18.728 15L9.62437 22.7381C9.20356 23.0958 9.15239 23.7269 9.51008 24.1477C9.86776 24.5685 10.4989 24.6196 10.9197 24.262L20.0233 16.5239C20.9629 15.7252 20.9629 14.2748 20.0233 13.4761L10.9197 5.73808C10.4989 5.38039 9.86776 5.43156 9.51008 5.85237Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.856d0376b1c79ede6b15d1880de12bdb.svg";
export { ForwardRef as ReactComponent };